import { render, staticRenderFns } from "./UserRechargeIndex.vue?vue&type=template&id=37998df6"
import script from "./UserRechargeIndex.vue?vue&type=script&lang=js"
export * from "./UserRechargeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports